import React, {Component} from 'react';
import StandardCRUD from "../../../components/StandardCRUD" //component that used for standard crud from

import data_field from './_field'; // fields form
import SidebarDataMaster from '../SidebarDataMaster';
import SectionDataView from '../../../containers/_layout/SectionDataView';


class SubKlasifikasi extends Component {
  constructor(props) {
    super(props);

    this.options = {
      sortIndicator: true,
      hideSizePerPage: true,
      paginationSize: 6,
      hidePageListOnlyOnePage: true,
      clearSearch: true,
      alwaysShowAllBtns: false,
      withFirstAndLast: false
    }
    this.state = {
      reload:false,
      loading: false,
      id_pk_column: 'id',
      id : this.props.match.params.id,
      url: { url_get_data : `/klasifikasi/${this.props.match.params.id}/sub_klasifikasi`, url_save_data: '/sub_klasifikasi', url_update_data: '/sub_klasifikasi',
             url_delete_data: '/sub_klasifikasi', url_get_data_per: '/sub_klasifikasi' },
      title: 'Master Sub Klasifikasi',
      title_add : 'Add Data Master Sub Klasifikasi', 
      fields: data_field.data, 
      url_parrent: `/master/kategori/${this.props.match.params.kategori_id}/klasifikasi`,
      columns: [ 
        { header: 'Klasifikasi', id: 'klasifikasi', accessor: 'klasifikasi', child_accessor: null,
            Cell: row => {
                return (row.value.nama.substring(0, 25) + (row.value.nama.length > 25 ? '.....' : ''))
            }
        },
        { header: 'Nama Sub Klasifikasi', id: 'nama', accessor: 'nama', child_accessor: null,
            Cell: row => {
                return (row.value.substring(0, 25) + (row.value.length > 25 ? '.....' : ''))
            }
        },        
    ],
    }
  }

  render() {
    return (
      <React.Fragment>
          <SidebarDataMaster location={this.props.location.pathname}/>
          <StandardCRUD 
                columns={this.state.columns} 
                url={this.state.url} 
                title={this.state.title} 
                title_add={this.state.title_add} 
                fields={this.state.fields} 
                id_pk={this.state.id} 
                add_form={true}
                id_pk_column={this.state.id_pk_column}
                style_container="content content-components"
                search_query=""
                search_column={true}
                url_parrent ={this.state.url_parrent}
          />
          <SectionDataView />
      </React.Fragment>
      
    );
  }
}

export default SubKlasifikasi;
